import { render, staticRenderFns } from "./BattlesBoxElement.vue?vue&type=template&id=de7c3916&scoped=true"
import script from "./BattlesBoxElement.vue?vue&type=script&lang=js"
export * from "./BattlesBoxElement.vue?vue&type=script&lang=js"
import style0 from "./BattlesBoxElement.vue?vue&type=style&index=0&id=de7c3916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7c3916",
  null
  
)

export default component.exports